import { AuthContext, Payment } from '@repo-level/core-front';
import { useContext } from 'react';

interface PaymentMethodCardProps {
  method: Payment.Method;
  index: number;
  onSelect: (method: Payment.Method) => void;
  currentMethod?: Payment.Method;
}

export const PaymentMethodCard = ({
  method,
  index,
  onSelect,
  currentMethod,
}: PaymentMethodCardProps) => {
  const { user } = useContext(AuthContext);

  return (
    <div key={`${method.id}_${index}`} className="button-wrapper">
      <button
        onClick={() => onSelect(method)}
        className={method.id === currentMethod?.id ? 'active' : ''}
      >
        <img
          src={method.iconSrc || undefined}
          alt={`${method.translationKey} logo`}
        />
      </button>
    </div>
  );
};
